import useLocation from "@hooks/useLocation"
import { addTraillingSlash } from "@lib/searchUtils"
import { navigate } from "gatsby"
import React, { useEffect } from "react"
import { usePropertyStore } from "../store/propertyStore"
import areas from './../../../../static/areas.json';
import offplanAreas from './../../../../static/offplan_areas.json';
const useAreaMultiSelect = ({ isOffPlan }) => {
  const [firstRender, setFirstRender] = React.useState(true)

  const { pathname } = useLocation()

  const [showSearchInput, setShowSearchInput] = React.useState(true)
  const searchText = usePropertyStore((state) => state.searchText)
  const setSearchText = usePropertyStore((state) => state.setSearchText)
  const searchSlug = usePropertyStore((state) => state.searchSlug)
  const setSearchSlug = usePropertyStore((state) => state.setSearchSlug)
  const areaJSON = usePropertyStore((state) => state.areaJSON)
  const offplanJSON = usePropertyStore((state) => state.offplanJSON)
  const setAreaJSON = usePropertyStore((state) => state.setAreaJSON)
  const setOffplanJSON = usePropertyStore((state) => state.setOffplanJSON)
  const selectedAreas = usePropertyStore((state) => state.selectedAreas)
  const addSelectedArea = usePropertyStore((state) => state.addSelectedArea)
  const removeSelectedArea = usePropertyStore(
    (state) => state.removeSelectedArea
  )
  const removeSelectedAreas = usePropertyStore(
    (state) => state.removeSelectedAreas
  )
  const removeAllSelectedAreas = usePropertyStore(
    (state) => state.removeAllSelectedAreas
  )
  const pDepartment = usePropertyStore((state) => state.pDepartment)

  const isOffplan = isOffPlan || pDepartment === "new_developments"

  useEffect(() => {
    setAreaJSON(areas)
    const filtered = offplanAreas.filter(item => item.type !== 'developer');
    setOffplanJSON(filtered)
  }, [])

  useEffect(() => {
    if (firstRender) {
      if (selectedAreas.length) {
        setShowSearchInput(false)
        setFirstRender(false)
      }
    } else {
      const isReultsPage =
        pathname?.includes("for-sale") || pathname?.includes("for-rent") || pathname?.includes("new-projects")

      // If we are on the results page and there are no selected areas then automatically navigate to the default results page
      if (isReultsPage && !selectedAreas.length && pathname) {
        const pathSegments = addTraillingSlash(pathname).split("/")

        const indexToRemove = pathSegments?.findIndex((segment) =>
          segment.includes("in-")
        )

        if (indexToRemove !== -1) {
          pathSegments.splice(indexToRemove, 1)

          // if (!pathSegments[3]?.includes("in-")) {
          //   // insert default area in the 3 index and keep the rest of the path
          //   pathSegments.splice(3, 0, `in-${DEFAULT_AREA}`)
          // }

          navigate(pathSegments.join("/"))
          // window.location.href === pathSegments.join("/")
          // window.location.replace(pathSegments.join("/"))
        }
      }
    }
  }, [selectedAreas, firstRender, pathname])

  const handleSelectArea = (area) => {
    setSearchText("")
    setSearchSlug("")
    addSelectedArea(area)
  }

  const handleRemoveArea = (area) => {
    removeSelectedArea(area)
  }

  const handleRemoveAreas = (areas) => {
    removeSelectedAreas(areas)
  }

  const handleRemoveAllAreas = () => {
    removeAllSelectedAreas()
  }

  return {
    searchText,
    setSearchText,
    areasSuggestionList: isOffplan ? offplanJSON : areaJSON,
    searchSlug,
    setSearchSlug,
    selectedAreas,
    showSearchInput,
    setShowSearchInput,
    handleSelectArea,
    handleRemoveArea,
    handleRemoveAreas,
    handleRemoveAllAreas,
  }
}

export default useAreaMultiSelect
